import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Phone } from 'react-feather';
import userlogo from '../user.webp';
import { Users, Award, Briefcase } from "react-feather";
import FeaturesBottom from './FeaturesBottom';

function Careers() {
    const cards = [
        {
        title: "Mission-driven work",
        text: "Be part of a company that is transforming retargetting, payments and unlocking opportunities across the continent.",
        icon: <Briefcase color="white" size={32} />,
        bgColor: "#009EDA",
        },
        {
        title: "Collaborative culture",
        text: "Work alongside diverse, talented teams who challenge and inspire each other every day.",
        icon: <Users color="white" size={32} />,
        bgColor: "#FFC000",
        },
        {
        title: "Career growth",
        text: "We invest in your development with learning opportunities, mentorship and leadership pathways.",
        icon: <Award color="white" size={32} />,
        bgColor: "#005BA0",
        },
    ];
    return (
        <>
            <Helmet>
                <title>Careers - Kadhr</title>
                <meta 
                    name="description" 
                    content="Work With Us — Let’s Simplify How the World Sells." 
                />
            </Helmet>
            <main className="mtopcon0 ovrflwhdn" id="up">
                <a href="https://wa.me/254794072134" target="_blank" rel="noopener noreferrer" className="wappcomms btn-hover float-left">
                    <Phone className="text-white" />
                </a>

                <div className="row">
                    <div className="col-12 text-center text-white pt-6indx">
                        <h1 className="mb-3 display-6 font-bold">
                            <b>
                                <span className="text-primary">We're</span> <span className="text-dark">Kadhr.</span>
                            </b>
                        </h1>
                        <p className="mb-4 font1 text-grey">
                            Work With Us — Let’s Simplify How Emerging Markets Sell ✨
                        </p>
                    </div>

                    <div className="col-12 pt-6indx0">
                        <div className="container containerwide">
                            <div className="row justify-content-center">
                                <div className="col-md-8">
                                    <div className="accordion" id="careersAccordion">

                                        <div className="accordion-item candidate-list-box card mt-4">
                                            <h2 className="accordion-header" id="jobOneHeading">
                                            <button
                                                className="accordion-button d-flex align-items-center bg-white"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#jobOne"
                                                aria-expanded="true"
                                                aria-controls="jobOne"
                                            >
                                                <div className="d-flex align-items-center w-100">

                                                {/* Avatar */}
                                                <div className="col-auto me-3">
                                                    <img
                                                    src={userlogo}
                                                    alt="avatar"
                                                    className="avatar-md img-thumbnail rounded-circle"
                                                    />
                                                </div>

                                                {/* Title + Summary */}
                                                <div className="flex-grow-1">
                                                    <h5 className="mb-0 fs-18">
                                                    Field Sales Associate
                                                    <span className="badge bg-success ms-2 hide">Hiring</span>
                                                    <span className="badge bg-dark text-white ms-2">Closed</span>
                                                    </h5>
                                                    <p className="text-muted mb-0">
                                                    Tech Sales · Nairobi (On-Ground)
                                                    </p>
                                                </div>

                                                </div>
                                            </button>
                                            </h2>

                                            <div
                                            id="jobOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="jobOneHeading"
                                            data-bs-parent="#careersAccordion"
                                            >
                                            <div className="accordion-body">

                                                {/* Full Job Description */}
                                                <h6 className="fw-bold">Role Overview</h6>
                                                <p>
                                                We’re looking for a skilled <b>Field Sales Associate</b> with experience in technology or SaaS 
                                                sales. In this role, you will identify new business opportunities, understand client 
                                                technology needs, and recommend the right Kadhr solutions through product demonstrations 
                                                and persuasive sales pitches. You will be responsible for closing deals, onboarding clients, 
                                                maintaining relationships, and representing Kadhr in the field.
                                                </p>

                                                <h6 className="fw-bold">Core Responsibilities</h6>

                                                <p className="fw-semibold mt-3 mb-1">Sales and Client Relations:</p>
                                                <ul>
                                                <li>Identify and qualify new business leads.</li>
                                                <li>Build and maintain strong relationships with new and existing customers.</li>
                                                <li>Conduct sales presentations, product demos, and close deals.</li>
                                                </ul>

                                                <p className="fw-semibold mt-3 mb-1">Technical and Strategic Duties:</p>
                                                <ul>
                                                <li>Assess client needs and recommend the most suitable Kadhr technology solutions.</li>
                                                <li>Stay informed on product specifications, industry trends, and competitors.</li>
                                                <li>Collaborate with internal technical teams and management on product offerings.</li>
                                                </ul>

                                                <p className="fw-semibold mt-3 mb-1">Performance and Administration:</p>
                                                <ul>
                                                <li>Achieve and exceed sales targets and performance metrics.</li>
                                                <li>Track and report on sales performance in a structured manner.</li>
                                                <li>Develop sales strategies and set achievable sales goals.</li>
                                                </ul>

                                                <h6 className="fw-bold">Key Skills & Qualifications</h6>
                                                <ul>
                                                <li>
                                                    <b>Technical Knowledge:</b> Ability to understand and explain software and automation tools 
                                                    to non-technical clients.
                                                </li>
                                                <li>
                                                    <b>Sales Acumen:</b> Strong negotiation, presentation, lead generation, and closing skills.
                                                </li>
                                                <li>
                                                    <b>Interpersonal Skills:</b> Excellent communication, confidence, and relationship-building 
                                                    abilities.
                                                </li>
                                                <li>
                                                    <b>Education:</b> A degree in BBIT, Business, Media, Sales, or any relevant program.
                                                </li>
                                                <li>
                                                    <b>Experience:</b> Minimum of 2 years in sales or customer-facing roles.  
                                                    Experience in tech sales or startup environments is a strong advantage.
                                                </li>
                                                </ul>

                                                <h6 className="fw-bold">Compensation</h6>
                                                <p>Competitive base pay + commissions + performance bonuses.</p>

                                                <h6 className="fw-bold">How to Apply</h6>
                                                <p>
                                                    Email your CV and a short cover note to:                                                  
                                                    <b><Link to={"mailto:careers@kadhr.com"} className='ms-2 me-1'>careers@kadhr.com</Link></b> by 8/12/2025
                                                </p>

                                            </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="container py-5">
                                        
                                        <div className="col-12 text-center text-white">
                                            <h1 className="mb-3 display-6 font-bold">
                                                <b>
                                                    <span className="text-primary">Why</span> <span className="text-dark">Kadhr.</span>
                                                </b>
                                            </h1>
                                            <p className="mb-4 font1 text-grey">
                                                ✨
                                            </p>
                                        </div>
                                        <div class="row g-4 justify-content-center text-left">
                                            {cards.map((card, index) => (
                                                <div key={index} className="col-12 col-lg-4">
                                                    <div className="card border-0 shadow-sm h-100">
                                                    <div className="card-body">
                                                        <div
                                                        className="d-inline-flex align-items-center justify-content-center mb-3 rounded"
                                                        style={{
                                                            width: "63px",
                                                            height: "63px",
                                                            backgroundColor: card.bgColor,
                                                        }}
                                                        >
                                                        {card.icon}
                                                        </div>
                                                        <h5 className="font-bold">{card.title}</h5>
                                                        <p className="card-text font9">{card.text}</p>
                                                    </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <FeaturesBottom/>
                </div>
            </main>
        </>
    );
}

export default Careers;
